import React from 'react';
import { createUseStyles } from 'react-jss';
import { FaCheck } from 'react-icons/fa';

import Text from '../../components/Text';
import clsx from 'clsx';

export interface StepperProps {
  steps: string[];
  currentStep: number;
  onClickStep: (step: string) => void;
}

const Stepper: React.FC<StepperProps> = ({
  steps,
  currentStep,
  onClickStep,
}) => {
  const classes = useStyles();
  const stepIDS = ['cart', 'payment', 'confirmation'];

  return (
    <div className={classes.stepper}>
      {steps.map((name, index) => (
        <div
          key={index}
          className={classes.step}
          onClick={
            index > currentStep ? () => {} : () => onClickStep(stepIDS[index])
          }
          style={{
            cursor: index > currentStep ? 'default' : 'pointer',
          }}
        >
          <Text
            className={classes.stepName}
            align={
              index === 0
                ? 'left'
                : index === steps.length - 1
                ? 'right'
                : 'center'
            }
            color="black"
            bold
          >
            {name}
          </Text>
          <div>
            <span
              className={clsx(classes.stepDot, {
                [classes.left]: index === 0,
                [classes.center]: index > 0 && index < steps.length - 1,
                [classes.right]: index === steps.length - 1,
              })}
            >
              {currentStep >= index ? (
                <FaCheck className={classes.stepIcon} />
              ) : null}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

const useStyles = createUseStyles({
  stepper: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '40px',
    marginBottom: '30px',
    '@media (max-width: 520px)': {
      marginTop: '70px',
    },
    '&:before': {
      content: '""',
      height: '3px',
      position: 'absolute',
      left: 0,
      right: 0,
      backgroundColor: '#522583',
    },
  },
  step: {
    position: 'relative',
    flex: 1,
  },
  stepName: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: '-30px',
    '@media (max-width: 520px)': {
      top: '-60px',
    },
  },
  stepDot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '32px',
    height: '32px',
    backgroundColor: '#522583',
    borderRadius: '50%',
  },
  stepIcon: {
    color: '#fff',
  },
  left: {
    marginRight: 'auto',
  },
  center: {
    margin: 'auto',
  },
  right: {
    marginLeft: 'auto',
  },
});

export default Stepper;
